import { render } from "./Iletisim.vue?vue&type=template&id=88fdc4bc"
import script from "./Iletisim.vue?vue&type=script&lang=js"
export * from "./Iletisim.vue?vue&type=script&lang=js"

import "./Iletisim.vue?vue&type=style&index=0&id=88fdc4bc&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__